import { NavMarker } from 'react-rhumb';
import { Metrics } from 'email-management-lib/Shared/utils/metrics';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ErrorMarker() {
  useEffect(() => {
    Metrics.timer('framework-error').update(performance.now());
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FRAMEWORK_TABLE_LOAD_FAILED"
  });
}